export const removeFiltersParams = (searchParams) => {
    const cleanedParams = new URLSearchParams(searchParams);
    cleanedParams.delete('chartEntity');
    cleanedParams.delete('intervals');
    cleanedParams.delete('tiersIds');
    cleanedParams.delete('devices');
    return cleanedParams;
};
